import { jsx as _jsx } from "nativewind/jsx-runtime";
import React, { useEffect, useRef } from 'react';
import { ScrollView } from 'react-native';
import styled from 'styled-components/native';
import { SccPressable } from '@/components/SccPressable';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
export default function V2ChipBar({ chips, activeIndex, onChipPress }) {
    const chipRefs = useRef({});
    const scrollRef = useRef(null);
    useEffect(() => {
        const chip = chipRefs.current[activeIndex];
        if (chip && scrollRef.current) {
            scrollRef.current.scrollTo({
                x: Math.max(0, chip.x - 20),
                animated: true,
            });
        }
    }, [activeIndex]);
    return (_jsx(Container, { children: _jsx(ChipScrollContainer, { ref: scrollRef, children: _jsx(ChipRow, { children: chips.map((chip, idx) => {
                    const isActive = idx === activeIndex;
                    return (_jsx(ChipButton, { isActive: isActive, elementName: `v2_accessibility_chip_${idx}`, onPress: () => onChipPress(idx), onLayout: e => {
                            chipRefs.current[idx] = {
                                x: e.nativeEvent.layout.x,
                                width: e.nativeEvent.layout.width,
                            };
                        }, children: _jsx(ChipText, { isActive: isActive, children: chip }) }, chip));
                }) }) }) }));
}
const Container = styled.View `
  background-color: ${color.white};
  padding-top: 12px;
  padding-bottom: 6px;
`;
const ChipScrollContainer = styled(ScrollView).attrs({
    horizontal: true,
    showsHorizontalScrollIndicator: false,
    contentContainerStyle: { paddingHorizontal: 20 },
}) ``;
const ChipRow = styled.View `
  flex-direction: row;
  gap: 8px;
`;
const ChipButton = styled(SccPressable) `
  border-width: 1px;
  border-color: ${({ isActive }) => (isActive ? color.brand40 : color.gray20)};
  border-radius: 100px;
  padding-horizontal: 14px;
  padding-vertical: 8px;
  background-color: ${({ isActive }) => (isActive ? color.brand40 : color.white)};
`;
const ChipText = styled.Text `
  font-family: ${font.pretendardMedium};
  font-size: 13px;
  line-height: 18px;
  letter-spacing: -0.26px;
  color: ${({ isActive }) => (isActive ? color.white : color.gray90)};
`;
